import Skeleton from 'components/LoadingSkeleton';

// Placeholder shown while the player's VAIR status (ambassador / rater) is
// still resolving, so the home page doesn't shift when VairProSection pops in.
// Mirrors the card footprint: stats on the left, map panel on the right.
export default function VairProSectionSkeleton() {
  return (
    <section className="container mx-auto">
      <div className="flex flex-col gap-6 overflow-hidden rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-secondary p-6 dark:bg-color-bg-darkmode-secondary xl:flex-row xl:items-center xl:gap-12">
        {/* Stats */}
        <div className="flex flex-col gap-6 xl:flex-row xl:items-center xl:gap-20">
          {[0, 1].map((i) => (
            <div key={i} className="flex flex-col items-center gap-3">
              <Skeleton width={140} height={16} />
              <Skeleton width={80} height={40} />
              <Skeleton width={180} height={40} borderRadius={9999} />
            </div>
          ))}
        </div>

        {/* Map */}
        <div className="xl:ml-auto">
          <Skeleton height={129} borderRadius={12} className="!w-full xl:!w-[337px]" />
        </div>
      </div>
    </section>
  );
}
